<table class="table-text-medium all-border">
    <thead>
        <tr>
            <th>CourseID</th>
            <th>Course Name</th>
            <th>LastAccess</th>
            <th>Completed Date</th>
            <th> Status</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let x of courses">
            <td>{{x.CourseID}}</td>
            <td>{{x.CourseName}}</td>
            <td>{{x.LastAccess | date : "MMM d, y h:mm "}}</td>
            <td>{{x.CompletionDate| date : "MMM d, y h:mm "}}</td>
            <td>{{x.Status}}</td>
        </tr>
    </tbody>

</table>